// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__HN-cA","varNumber":"Variant_varNumber__fHTI-","varTitle":"Variant_varTitle__DhjIx"};